export default __webpack_public_path__ + "static/media/SO.235bc705.svg";